import React from "react";
import styled from "styled-components";

import * as UserContext from "./UserContext";
import ImageInitials from "./ImageInitials";
import { Button } from "./Button";
import * as u from "../utils";

export default function ActivityCommentTextArea(props) {
  const userInfo = React.useContext(UserContext.Context);
  const textAreaRef = React.useRef(null);
  const [text, setText] = React.useState();

  React.useEffect(onChangeAreaHeight, [text]);

  const noWhitespace = /[^\s-]/;
  const hasText = text && noWhitespace.test(text);

  return (
    <S.Container isSmall={props.isSmall}>
      <S.Comment>
        {!props.isSmall && userInfo.id && <ImageInitials {...userInfo} />}
        <S.TextArea
          ref={textAreaRef}
          placeholder={"Leave a comment..."}
          value={text}
          onChange={(e) => setText(e.target.value)}
          isSmall={props.isSmall}
        />
      </S.Comment>
      {hasText && (
        <S.Button
          onClick={onClick}
          size="sml"
          text={props.isSmall ? "Reply" : "Comment"}
        />
      )}
    </S.Container>
  );

  function onChangeAreaHeight() {
    if (!textAreaRef.current) return;
    // set the height to 0 in case
    // of it has to be shrinked
    const minHeight = props.isSmall ? 30 : 50;
    textAreaRef.current.style.height = 0;
    textAreaRef.current.style.height =
      Math.max(minHeight, textAreaRef.current.scrollHeight) + "px";
    if (props.isSmall) textAreaRef.current.focus();
  }

  function onClick() {
    if (!(text && userInfo.id) || !hasText) return;
    textAreaRef.current.blur();
    props.onPost(text);
    setText("");
  }
}

const S = {};

S.Container = styled.div`
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 0 15px;
  ${(props) =>
    props.isSmall
      ? `
  align-items: flex-end;
  padding: 0;
  `
      : ``}
  @media ${u.device.tablet} {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
`;

S.Comment = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`;

S.Button = styled(Button)`
  margin: 5px 10px 5px auto;
`;

S.TextArea = styled.textarea`
  flex: 1;
  height: 50px;
  outline: none;
  border: none;
  resize: none;
  padding: 5px;
  padding-top: 16px;
  margin-left: 10px;
  font-size: 1.4rem;
  white-space: nowrap;
  color: ${u.colours.charcoal};
  ${(props) =>
    props.isSmall
      ? `
    height: 30px;
    padding-top: 6px;
    padding-left: 15px;
    margin-left: 0;
    margin-right: 10px;
    border-radius: 20px;
  `
      : ``}
`;
